<template>
  <table v-if="load === 'success'" class="plc-tableTransactions">
    <tr v-for="tx in txs" :key="tx.txid" class="plc-tableTransactions__row">
      <td class="plc-tableTransactions__cell plc-tableTransactions__cell--status">
        <gl-transaction-icon :type="tx.type" />
      </td>
      <td class="plc-tableTransactions__cell plc-tableTransactions__cell--truncate">
        <router-link
          :to="{ name: 'Transaction', params: { id: tx.txid } }"
          class="text-link text-truncate"
        >
          {{ tx.txid }}
        </router-link>
      </td>
      <td class="plc-tableTransactions__cell">
        <span class="text text--light">{{ asTimeAgo(tx.time) }}</span>
      </td>
      <td class="plc-tableTransactions__cell">
        <gl-status variant="outline-primary" class="plc-tableTransactions__btn">
          {{ tx.outputsValue / 100000000 }} PLC
        </gl-status>
      </td>
    </tr>
  </table>

  <div v-else-if="load === 'error'" style="color: rgba(255, 255, 255, 0.38); margin-top: 32px;">
    Unexpected Error!
  </div>

  <gl-loader v-else />
</template>

<script>
import GlStatus from '@gl/GlStatus'
import GlTransactionIcon from '@gl/GlTransactionIcon'
import GlLoader from '@gl/GlLoader'
import { updatePeriod } from '@/config'
import { getTxLast } from '@/services/api'
import { formatDistance } from 'date-fns'

export default {
  name: 'HomeTransactionsTable',
  components: { GlTransactionIcon, GlStatus, GlLoader },
  data() {
    return {
      load: 'loading',
      timer: null,
      txs: [],
    }
  },
  mounted() {
    this.loadBlockInfo()
    this.timer = setInterval(() => {
      this.loadBlockInfo()
    }, updatePeriod)
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    async loadBlockInfo() {
      const { data } = await getTxLast()
      if (data.state === 'success') {
        this.txs = data.data
        this.load = 'success'
      } else if (!this.txs.length) {
        this.load = 'error'
      }
    },
    asTimeAgo(time) {
      return formatDistance(new Date(time), new Date(), { addSuffix: true })
    },
  },
}
</script>

<style lang="scss" scoped>
.plc-tableTransactions {
  $this: &;

  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  width: 100%;

  @media (min-width: $breakpoint-md) {
    table-layout: auto;
  }

  &__header {
    background-color: rgba(255, 255, 255, 0.15);
    height: 48px;
  }

  &__row {
    &:nth-child(even) {
      background-color: rgba(255, 255, 255, 0.07);
    }
  }

  &__cell {
    @include text-truncate;

    color: #fff;
    font-size: 14px;
    line-height: 24px;

    @media (max-width: $breakpoint-md - 1) {
      display: block;
      padding: 4px 16px;
      text-align: center;
      width: 100%;
    }

    @media (min-width: $breakpoint-md) {
      padding: 12px;
      width: 1%;
    }

    &:first-of-type {
      @media (max-width: $breakpoint-md - 1) {
        padding-top: 8px;
      }
    }

    &:last-of-type {
      @media (max-width: $breakpoint-md - 1) {
        padding-bottom: 8px;
      }
    }

    &--status {
      @media (min-width: $breakpoint-md) {
        min-width: 52px;
        text-align: center;
      }
    }

    &--truncate {
      @media (min-width: $breakpoint-md) {
        max-width: 0;
        width: 100%;
      }
    }
  }

  &__btn {
    width: 100%;
  }
}
</style>
